import { Link } from 'react-router-dom';
import styles from './NoPage.module.css';

const NoPage = () => (
  <div className={styles.container}>
    <h1>404</h1>
    <p>Page not found.</p>
    <Link to="/" className={styles.link}>Back to home</Link>
  </div>
);

export default NoPage;
